

exports.__esModule = true;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-preferred-checkbox',
    template: _template2['default'],
    props: {
        makeFiPreferred: {
            type: 'var',
            required: true
        },
        plan: {
            type: 'var',
            required: true
        }
    },
    actions: {
        toggleModel: function toggleModel() {
            if (this.props.makeFiPreferred.selected) {
                this.props.makeFiPreferred.planId = this.props.plan.planId;
                this.props.makeFiPreferred.fiId = this.props.plan.primaryFs.id;
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            if (this.props.plan.primaryFs.id && !this.props.plan.primaryFs.isPreferred) {
                _logger.$logger.info('checkout_fpti', {
                    'pref_fi_option_shown': '1'
                });
            }
        }
    }
});


_squid.$Component;

_logger.$logger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/preferred-checkbox/directive.js
// module id = ./components/xo-member-components/src/preferred-checkbox/directive.js
// module chunks = 1